import { Field } from "app/models/surveyScheme/field";

export abstract class Section {
  public title: string;
}


export class BlockSection extends Section {
  public fields: Field[];
}

export class TableSection extends Section {
  public tuples: Field[][];
}



// WEBPACK FOOTER //
// /app/SPA/src/app/models/surveyScheme/section.ts